import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    courseUuid: String,
    lessonId: String,
    introViewed: Boolean
  }

  connect() {
    // If intro hasn't been viewed, show the modal when the page loads
    if (!this.introViewedValue) {
      this.show()
    }
  }

  show() {
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  hide() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }

  startLesson(event) {
    event.preventDefault()

    // Mark intro as viewed
    this.markIntroAsViewed()

    // Hide the modal
    this.hide()

    // Initialize player and autoplay the video
    this.initializePlayerAndAutoplay()
  }

  skipIntro(event) {
    event.preventDefault()

    // Mark intro as viewed
    this.markIntroAsViewed()

    // Hide the modal (without autoplaying)
    this.hide()

    // Initialize player (but don't autoplay)
    this.initializePlayer()
  }

  markIntroAsViewed() {
    if (!this.lessonIdValue || !this.courseUuidValue) return

    const url = `/courses/${this.courseUuidValue}/lessons/${this.lessonIdValue}/mark_intro_viewed`

    post(url, {
      responseKind: 'json'
    }).then(response => {
      if (!response.ok) {
        console.warn('Failed to mark intro as viewed')
      }
    }).catch(error => {
      console.warn('Error marking intro as viewed:', error)
    })
  }

  initializePlayer() {
    // Find the course-lesson controller and initialize the player
    const courseLessonElement = document.querySelector('[data-controller="course-lesson"]')
    if (courseLessonElement) {
      const controller = this.application.getControllerForElementAndIdentifier(
        courseLessonElement,
        'course-lesson'
      )

      if (controller) {
        controller.initializePlayer()
      }
    }
  }

  initializePlayerAndAutoplay() {
    // Find the course-lesson controller and initialize + autoplay
    const courseLessonElement = document.querySelector('[data-controller="course-lesson"]')
    if (courseLessonElement) {
      const controller = this.application.getControllerForElementAndIdentifier(
        courseLessonElement,
        'course-lesson'
      )

      if (controller) {
        controller.initializePlayer()
        // Wait a bit for player to be ready before autoplaying
        setTimeout(() => {
          if (controller.player) {
            try {
              controller.player.playVideo()
            } catch (error) {
              console.warn('Error autoplaying video:', error)
            }
          }
        }, 500)
      }
    }
  }
}
